import { __assign, __read, __spread } from "tslib";
import chromatism from 'chromatism';
export var hexToRGBA = function (hex, opacity) {
    if (opacity === void 0) { opacity = 1; }
    var rgba = __assign(__assign({}, chromatism.convert(hex).rgb), { a: opacity });
    return "rgba(" + Object.values(rgba).join(', ') + ")";
};
export var getBoxShadow = function (color) { return "0 0 0 2px " + color; };
var hex = '[a-z0-9]';
var shortHandHexColorPattern = new RegExp("#(" + hex + ")(" + hex + ")(" + hex + ")", 'i');
var repeat = function (str, times) {
    return __spread(Array(times)).map(function () { return str; }).join('');
};
var isShortHexColor = function (color) { return color && color.length === 4; };
var completeHexColor = function (colors) {
    var hex = colors.map(function (color) { return repeat(color, 2); }).join('');
    return "#" + hex;
};
var completeTriplet = function (colors) { return "#" + repeat(colors[1], 6); };
var isTriplet = function (colors) {
    return colors[0] === colors[1] && colors[1] === colors[2];
};
export var convertHexShorthand = function (color) {
    if (isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        var matches = color.match(shortHandHexColorPattern);
        if (matches) {
            var colors = matches.slice(1, 4);
            if (isTriplet(colors)) {
                return completeTriplet(colors);
            }
            else {
                return completeHexColor(colors);
            }
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};
export var generateTextColor = function (color) {
    var converted = convertHexShorthand(color);
    return chromatism.contrastRatio(converted).hex;
};
export var getContrastColor = function (contrastValue, opacityValue, color) { return hexToRGBA(chromatism.contrast(contrastValue, color).hex, opacityValue); };
//# sourceMappingURL=themeHelpers.js.map